import React, { useEffect, useState } from 'react';
import { Box, Button, Checkbox, Typography } from '@material-ui/core';
import { AutocompleteRenderOptionState } from '@material-ui/lab';
import { clearPhoneNumberFormat } from 'helper';
import { IConsultingTypeModel, INewConsulting } from 'interfaces';
import MessageDialog from 'dialogs/MessageDialog';
import { SelectRefactor } from 'components/OldSelect';
import { createConsulting, getConsultingList } from './api';

interface IConsultingProps {
  callChainId: string;
  contactName: string;
  incomePhone: string;
  realEstateGuid: string;
  roomGuid: string;
}

const Consulting: React.FC<IConsultingProps> = ({
  incomePhone,
  realEstateGuid,
  callChainId,
  roomGuid,
  contactName,
}) => {
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [consultingList, setConsultingList] = useState<IConsultingTypeModel[]>([]);
  const [selectedConsultingList, setSelectedConsultingList] = useState<IConsultingTypeModel[]>([]);
  const [updateMessage, setUpdateMessage] = useState(false);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    setLoading(true);

    getConsultingList()
      .then(setConsultingList)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSend = (): void => {
    let isAnonymous = false;
    setSending(true);

    const data: INewConsulting = {
      incomePhone: clearPhoneNumberFormat(incomePhone, '+7'),
      details: selectedConsultingList.map((item) => ({
        consultationTypeId: item.consultationTypeId,
      })),
    };

    selectedConsultingList.forEach((item: IConsultingTypeModel) => {
      if (item.consultationTypeId === 10) isAnonymous = true;
    });

    if (realEstateGuid) data.realEstateGuid = realEstateGuid;
    if (callChainId) data.callChainId = callChainId;
    if (roomGuid) data.callChainId = roomGuid;
    if (contactName && !isAnonymous) data.contactName = contactName;

    if (roomGuid && !isAnonymous) data.roomGuid = roomGuid;

    createConsulting(data)
      .then(() => {
        setSelectedConsultingList([]);
        setUpdated(true);
      })
      .catch(() => {
        setUpdated(false);
      })
      .finally(() => {
        setSending(false);
        setUpdateMessage(true);
      });
  };

  const renderOption = (option: IConsultingTypeModel, { selected }: AutocompleteRenderOptionState) => {
    return (
      <>
        <Checkbox color="primary" checked={selected} style={{ marginRight: 8 }} />
        {option.consultationDesc}
      </>
    );
  };

  return (
    <Box sx={{ borderRadius: 8, overflow: 'hidden' }}>
      <Box sx={{ bgcolor: '#fdd7e7', py: 1, px: 2.5 }}>
        <Typography style={{ color: '#896675' }}>Консультация</Typography>
      </Box>

      <Box sx={{ bgcolor: '#E9EDF2', py: 2, px: 2.5 }}>
        <SelectRefactor
          label="Выбрать"
          optionDefaultLabel="consultationDesc"
          options={consultingList}
          value={selectedConsultingList}
          onChange={setSelectedConsultingList}
          limitTags={1}
          disabled={loading || sending || !incomePhone}
          loading={loading}
          getOptionLabel={(option: IConsultingTypeModel) => option.consultationDesc}
          disableCloseOnSelect
          renderOption={renderOption}
          multiple
        />

        <Box sx={{ mt: 1 }}>
          <Button
            variant="text"
            color="primary"
            disabled={!selectedConsultingList.length || loading || sending || !incomePhone}
            onClick={handleSend}
          >
            Отправить
          </Button>
        </Box>

        <MessageDialog
          open={updateMessage}
          isSuccess={updated}
          errorText="Консультация не зарегистрирована"
          successText="Консультация зарегистрирована"
          onContinue={() => setUpdateMessage(false)}
        />
      </Box>
    </Box>
  );
};

export default Consulting;
